// Imports //

// Variables //
const navbarListEl = document.querySelector(".navbar__list");
const navbarItemsEl = document.querySelectorAll(".navbar__item");
const navbarToggleEl = document.querySelector(".navbar__toggle");

const columnTwoBtnEl = document.getElementById("columnTwoBtn");
const columnTwoOneBtnEl = document.getElementById("columnTwoOneBtn");
const columnThreeBtnEl = document.getElementById("columnThreeBtn");

const rowBgEl = document.getElementById("rowBg");
const colOneBgEl = document.getElementById("colOneBg");
const textarea1El = document.getElementById("columnOneContent");
const colTwoBgEl = document.getElementById("colTwoBg");
const textarea2El = document.getElementById("columnTwoContent");
const colThreeBgEl = document.getElementById("colThreeBg");
const textarea3El = document.getElementById("columnThreeContent");
const paragraphColEl = document.getElementById("columnParagraphBtn");

const rowBgPickerEl = document.getElementById("rowBgPicker");
const colOneBgPickerEl = document.getElementById("colOneBgPicker");
const colTwoBgPickerEl = document.getElementById("colTwoBgPicker");
const colThreeBgPickerEl = document.getElementById("colThreeBgPicker");

const colorSchemesDivEl = document.querySelector(".color-schemes");
const colorBoxesEl = document.querySelectorAll(".color-schemes__box");

const copyToClipboardBtnEl = document.getElementById("copyToClipboardBtn");

const colorSchemesArr = [
  {
    rowBg: "#f8f9fa",
    colBg: "#f8f9fa",
    text: "#212529",
  },
  {
    rowBg: "#e2e8f0",
    colBg: "#f1f5f9",
    text: "#212529",
  },
  {
    rowBg: "#fecaca",
    colBg: "#fee2e2",
    text: "#212529",
  },
  {
    rowBg: "#fef08a",
    colBg: "#fef9c3",
    text: "#212529",
  },
  {
    rowBg: "#d9f99d",
    colBg: "#ecfccb",
    text: "#212529",
  },
  {
    rowBg: "#a5f3fc",
    colBg: "#cffafe",
    text: "#212529",
  },
  {
    rowBg: "#bfdbfe",
    colBg: "#dbeafe",
    text: "#212529",
  },
  {
    rowBg: "#ddd6fe",
    colBg: "#ede9fe",
    text: "#212529",
  },
  {
    rowBg: "#c7d2fe",
    colBg: "#e0e7ff",
    text: "#212529",
  },
  // Dark bg
  {
    rowBg: "#0f172a",
    colBg: "#334155",
    text: "#f8f9fa",
  },
  {
    rowBg: "#14532d",
    colBg: "#15803d",
    text: "#f8f9fa",
  },
  {
    rowBg: "#1e3a8a",
    colBg: "#1d4ed8",
    text: "#f8f9fa",
  },
  {
    rowBg: "#312e81",
    colBg: "#4338ca",
    text: "#f8f9fa",
  },
  {
    rowBg: "#881337",
    colBg: "#be123c",
    text: "#f8f9fa",
  },
];

// Navbar Toggle //
if (navbarToggleEl) {
  navbarToggleEl.addEventListener("click", () => {
    navbarListEl?.classList.toggle("navbar__toggle--open");
  });

  navbarItemsEl.forEach((item) => {
    item.addEventListener("click", () => {
      navbarListEl?.classList.toggle("navbar__toggle--open");
    });
  });
}

// Copy to Clipboard //
function copyToClipboard(text) {
  navigator.clipboard
    .writeText(text)
    .then(() => alert("Copied to clipboard!"))
    .catch((err) => console.error("Failed to copy text: ", err));
}

window.copyToClipboard = copyToClipboard;

// Delete Confirmation //
function confirmDelete(url) {
  const userConfirmed = confirm(
    "Are you sure you want to delete this item? If it is used elsewhere, the link will be broken."
  );

  if (userConfirmed) {
    window.location.href = url;
  }
}

window.confirmDelete = confirmDelete;

// Generate Color Schemes //
function generateColorSchemes(colorSchemeArr) {
  const fragment = document.createDocumentFragment();

  function applyColors(colors) {
    rowBgEl.value = `background-color: ${colors[0]}; color: ${colors[2]};`;
    colOneBgEl.value = `background-color: ${colors[1]};`;
    colTwoBgEl.value = `background-color: ${colors[1]};`;
    if (colThreeBgEl) {
      colThreeBgEl.value = `background-color: ${colors[1]};`;
    }

    rowBgPickerEl.value = colors[0];
    colOneBgPickerEl.value = colors[1];
    colTwoBgPickerEl.value = colors[1];
    if (colThreeBgPickerEl) {
      colThreeBgPickerEl.value = colors[1];
    }
  }

  colorSchemeArr.forEach((colorSet) => {
    const box = document.createElement("div");
    box.className = "color-schemes__box";
    box.setAttribute(
      "data-colors",
      `${colorSet.rowBg}, ${colorSet.colBg}, ${colorSet.text}`
    );

    ["rowBg", "colBg"].forEach((key) => {
      const span = document.createElement("span");
      span.className = "color-schemes__color";
      span.style.backgroundColor = colorSet[key];
      box.appendChild(span);
    });

    box.addEventListener("click", () => {
      const colorsData = box.getAttribute("data-colors");
      if (!colorsData) return;

      const colors = colorsData.split(", ");
      if (colors.length >= 3) {
        applyColors(colors);
      }
    });

    fragment.appendChild(box);
  });

  colorSchemesDivEl?.appendChild(fragment);
}

if (colorSchemesDivEl) generateColorSchemes(colorSchemesArr);

// Code Generator //
function columnCodeGenerator() {
  const width = columnThreeBtnEl ? "w-33" : columnTwoOneBtnEl ? "w-75" : "w-50";

  let generatedCode = `<p class="section-start"></p>
<!-- Section Start -->
<div class="flexbox" style="${rowBgEl?.value || ""}">
  <div class="${width}" style="${colOneBgEl?.value || ""}">
    <!-- Content -->
    ${textarea1El?.value || ""}
  </div>
  <div class="${!columnTwoOneBtnEl ? width : "w-25"}" style="${
    colTwoBgEl?.value || ""
  }">
    <!-- Content -->
    ${textarea2El?.value || ""}
  </div>`;

  if (columnThreeBtnEl) {
    generatedCode += `
  <div class="w-33" style="${colThreeBgEl?.value || ""}">
    <!-- Content -->
    ${textarea3El?.value || ""}
  </div>`;
  }

  generatedCode += `
</div>
<!-- Section End -->
<p class="section-end"></p>`;

  if (paragraphColEl) {
    generatedCode = `<p class="section-start"></p>
<!-- Section Start -->
<article class="w-para">
  <!-- Content -->
  ${textarea1El?.value || ""}
</article>
<p class="section-end"></p>`;
  }

  document.getElementById("output").textContent = generatedCode;
  return generatedCode;
}

// Color Pickers //
[rowBgPickerEl, colOneBgPickerEl, colTwoBgPickerEl, colThreeBgPickerEl].forEach(
  (picker, index) => {
    if (picker) {
      picker.addEventListener("change", (e) => {
        const targets = [rowBgEl, colOneBgEl, colTwoBgEl, colThreeBgEl];
        targets[index].value = `background-color: ${e.target.value};`;
      });
    }
  }
);

// Button Listeners //
[columnTwoBtnEl, columnTwoOneBtnEl, columnThreeBtnEl, paragraphColEl].forEach(
  (btn) => {
    btn?.addEventListener("click", columnCodeGenerator);
  }
);

copyToClipboardBtnEl?.addEventListener("click", () => {
  const generatedCode = columnCodeGenerator();
  copyToClipboard(generatedCode);
  // document.querySelector(".form").reset();
});

// Blog Links and Cards //

document
  .getElementById("blogLinksCopyBtn")
  ?.addEventListener("click", function () {
    const htmlLinks = blogLinkArr
      .map(
        (item) =>
          `<li><a href="/blog/index.php?todo=blog_show&blogId=${item.blogId}" class="btn btn--link">${item.blogTitle}</a></li>`
      )
      .join("\n");

    const template = `<h3 class="heading-3">Recent Blogs</h3>
<hr/>
<ol>
  ${htmlLinks}
</ol>`;

    copyToClipboard(template);
  });

function blogCardCopy(blogObj) {
  const template = `<div class="card-blog">
  <p class="card-blog__category">${blogObj.blogCategory}</p>
  <h3 class="heading-3">${blogObj.blogTitle}</h3>
  <p><strong>Tags:</strong> ${blogObj.blogTags}</p>
  <p>${blogObj.blogDescription}</p>
  <div>
    <a href="/blog/index.php?todo=blog_show&blogId=${blogObj.blogId}" class="btn btn--primary">Read More</a>
  </div>
</div>`;
  copyToClipboard(template);
}
window.blogCardCopy = blogCardCopy;

function formReset() {
  document.querySelector(".form").reset();
}
window.formReset = formReset;
